// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__198nt","background":"styles_background__DzgoS","action":"styles_action__1KFJa","title":"styles_title__UQcMu","image":"styles_image__2kK0b"};